<template>
  <layout name="BaseLayout">
    <div>
      <v-data-table ref="dataTable" dense :headers="tableHeaders" :items="items" :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc" class="elevation-1" :loading="loading" :loading-text="loadingText" :footer-props="{
          itemsPerPageOptions: rowsPerPage,
          itemsPerPageAllText: allTextForPerPage,
          itemsPerPageText: itemsPerPageText,
        }" :options="options" :no-results-text="filtersNoResultText" :multi-sort="true">
        <!-- formatear el texto de la paginacion -->
        <template v-slot:footer.page-text="props">
          {{ props.pageStart }} - {{ props.pageStop }} de
          {{ props.itemsLength }}
        </template>

        <!-- cabecera (toolbar + filtros) antes del header de la tabla -->
        <template v-slot:top>
          <v-toolbar text color="white">
            <v-toolbar-title>Grupos</v-toolbar-title>

            <v-divider class="mx-4" inset vertical></v-divider>

            <v-btn :loading="loading" :disabled="loading" @click="refreshItems" text color="primary">
              Actualizar
              <v-icon right dark>mdi-refresh</v-icon>
            </v-btn>

            <template v-if="userCanEdit && isShowCrearGrupos()">
              <v-divider class="mx-4" inset vertical v-if="isShowAddGrupo"></v-divider>

              <span>Creación de grupos:</span>
              <v-btn @click="crearGrupos" text color="primary" :loading="loadingCrearGrupos"
                :disabled="loadingCrearGrupos">Crear
              </v-btn>
            </template>

            <template v-if="userCanEdit && isShowCrearAulas()">
              <v-divider class="mx-4" inset vertical v-if="isShowAddGrupo"></v-divider>

              <span>Creación de aulas:</span>

              <v-btn @click="procesoCrearAulas" text color="primary" :loading="loadingCrearAulas"
                :disabled="loadingCrearAulas">Crear
              </v-btn>
            </template>

            <template v-if="(userCanEdit || userCanEditLlodio) && isShowAddGrupo">
              <v-spacer></v-spacer>

              <v-btn @click="addGrupo" text dark color="primary">
                <v-icon right dark>mdi-plus</v-icon>
                <span class="ml-1">Añadir</span>
              </v-btn>
            </template>
          </v-toolbar>

          <!-- Filtros -->
          <v-container fluid>
            <v-row class="pl-3 pr-3 pt-1">
              <!-- Filtrar en localizacion -->
              <v-col class="pt-0 pb-0" cols="4" v-if="userRoles !== undefined &&
                locationFilterAllowedRoles.includes(userRoles[0])
                ">
                <v-select class="pt-0 pb-0" :items="localizaciones" item-text="nombre" item-value="nombre"
                  label="Localizaciones" v-model="searchLocalizacion" clearable @change="cargarIdiomas"
                  :no-data-text="selectNoDataText" />
              </v-col>

              <!-- Filtrar en idioma -->
              <v-col class="pt-0 pb-0" cols="4">
                <v-select class="pt-0 pb-0" :items="idiomas" item-text="nombre" item-value="nombre" label="Idiomas"
                  v-model="searchIdioma" clearable @change="cargarNiveles" :no-data-text="selectNoDataText"
                  :disabled="!searchLocalizacion" />
              </v-col>

              <!-- Filtrar en nivel -->
              <v-col class="pt-0 pb-0" cols="4">
                <v-select class="pt-0 pb-0" :items="niveles" label="Nivel" v-model="searchNivel" clearable
                  item-text="descripcion" item-value="descripcion" :no-data-text="selectNoDataText"
                  :disabled="!searchIdioma" />
              </v-col>
            </v-row>

            <!-- Boton borrado de filtros-->
            <v-row v-if="showDeleteFilters" class="pa-0">
              <v-col cols="12" justify="center" align="center">
                <v-btn text dark color="primary" @click="borrarFiltros">
                  Borrar Filtros
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
          <!-- ./Filtros-->
        </template>

        <!-- columna de acciones -->
        <template v-if="userCanEdit" v-slot:item.actions="{ item }">
          <v-btn v-if="item.plazasOcupadas == 0" small color="red" icon dark @click="removeGrupo(item)">
            <v-icon small>
              mdi-delete
            </v-icon>
          </v-btn>
        </template>

        <!-- combo de edicion para la columna aula -->
        <template v-if="userCanEdit || userCanEditLlodio" v-slot:item.aula.numero="props">
          <v-edit-dialog :return-value.sync="props.item.aula" @save="saveAula(props.item)" @cancel="cancelAula"
            @open="openAula(props.item, props.item.aula)" @close="closeAula" large persistent
            :cancel-text="editDialogCancelText" :save-text="editDialogSaveText">
            <!-- <div>{{ props.item.aula.numero }}</div> -->
            <div>{{ parseNumeroAula(props.item.aula) }}</div>

            <template v-slot:input>
              <div class="mt-4 title">Actualizar Aula</div>
            </template>

            <template v-slot:input>
              <v-autocomplete :items="aulas" label="Aulas" :value="props.item.aula"
                :search-input.sync="autocompleteAulasValue" clearable item-text="numero" hide-no-data allow-overflow
                @change="saveAulaTemp" return-object></v-autocomplete>
            </template>
          </v-edit-dialog>
        </template>

        <!-- input de texto para la edicion de la columna de Grupos -->
        <template v-if="userCanEdit || userCanEditLlodio" v-slot:item.grupos="props">
          <v-edit-dialog :return-value.sync="props.item.grupos" @save="saveGrupos(props.item)" @cancel="cancelGrupos"
            @open="openGrupos(props.item, props.item.grupos)" @close="closeGrupos" large persistent
            :cancel-text="editDialogCancelText" :save-text="editDialogSaveText">
            <div>{{ props.item.grupos }}</div>

            <template v-slot:input>
              <div class="mt-4 title">Actualizar Grupos</div>
            </template>

            <template v-slot:input>
              <v-text-field label="Grupos" :value="props.item.grupos" @change="saveGruposTemp" clearable></v-text-field>
            </template>
          </v-edit-dialog>
        </template>

        <!-- Se muestra con resultado vacio -->
        <template v-slot:no-data>
          {{ filtersNoResultText }}
        </template>
      </v-data-table>

      <!-- fullscreen añadir nuevo grupo -->
      <template>
        <v-row justify="center">
          <v-dialog v-model="dialogFullScreen" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
              <!-- cabecera full screen -->
              <v-toolbar dark color="primary">
                <v-btn icon dark @click="closeDialogFullScreen">
                  <v-icon>mdi-close</v-icon>
                </v-btn>

                <v-toolbar-title>Añadir nuevo Grupo</v-toolbar-title>
              </v-toolbar>

              <!-- contenido fullscreen -->
              <GrupoForm :localizaciones="localizaciones" @submitAddGrupo="onAddGrupo"
                @submitErrorAddGrupo="onErrorAddGrupo" />
            </v-card>
          </v-dialog>
        </v-row>
      </template>

      <!-- popup de confirmación de borrado -->
      <confirm ref="grupoConfirm"></confirm>
    </div>
  </layout>
</template>

<script>
import Layout from "@/components/layouts/Layout";
import GrupoForm from "@/components/grupo/GrupoForm";
import { mapGetters, mapMutations } from "vuex";
import {
  getByCurso,
  update,
  remove,
  duplicar,
  crearAulas,
} from "@/api/grupos.api";
import _ from "lodash";
import Confirm from "@/components/Confirm";

export default {
  name: "Grupos",

  components: {
    Layout,
    GrupoForm,
    Confirm,
  },

  data: () => ({
    items: [],
    headers: [],
    idiomas: [],
    niveles: [],
    aulas: [],
    sortBy: [
      "nivel.idioma.nombre",
      "nivel.descripcion",
      "dia.descripcionCorta",
      "horario.descripcion",
    ],
    sortDesc: [false, false, false, false],
    rowsPerPage: [25, 50, 75, 100, -1],
    options: {
      itemsPerPage: 25,
    },
    loading: false,
    aulasLoading: false,

    // valores de los filtros
    searchLocalizacion: "",
    searchIdioma: "",
    searchNivel: "",

    // textos varios
    filtersNoResultText: "No se han encontrado resultados",
    loadingText: "Cargando ...",
    itemsPerPageText: "Filas por página:",
    allTextForPerPage: "Todas",
    selectNoDataText: "No hay valores",
    editDialogCancelText: "Cancelar",
    editDialogSaveText: "Guardar",

    // columnas editables
    aulaEditedIndex: -1,
    gruposEditedIndex: -1,
    aulaEditedItem: null,
    gruposEditedItem: null,
    aulaTemp: null,
    gruposTemp: null,
    autocompleteAulasValue: "",

    // dialog edicion y tabs
    dialogFullScreen: false,

    // accion generar grupos
    loadingCrearGrupos: false,

    // accion generar grupos
    loadingCrearAulas: false,

    // listados de roles para determinar uso de filtros
    locationFilterAllowedRoles: ["ROLE_SUPER_ADMIN"],
  }),

  watch: {
    cursoActual() {
      this.items = [];
      this.initialize();
    },
  },

  created() {
    this.initialize();
  },

  computed: {
    ...mapGetters("App", {
      cursoActual: "GET_CURSO_ACTUAL",
      localizaciones: "GET_LOCALIZACIONES",
    }),

    ...mapGetters("Auth", {
      userCanEdit: "userCanEdit",
    }),

    ...mapGetters("Auth", {
      userCanEditLlodio: "userCanEditLlodio",
    }),

    ...mapGetters("Auth", {
      userRoles: "authRoles",
    }),

    tableHeaders() {
      return this.headers;
    },

    showDeleteFilters() {
      return this.searchLocalizacion || this.searchIdioma || this.searchNivel;
    },
  },

  methods: {
    ...mapMutations("Snack", {
      setSnack: "SET_SNACK_OPTIONS",
    }),

    /**
     * inicializa todos los valores necesarios del componente
     */
    async initialize() {
      this.loading = true;

      if (this.cursoActual) {
        this.headers = [
          {
            text: "Localización",
            align: "start",
            value: "localizacion.nombre",
            filter: (value) => {
              return this.filtrarLocalizacion(value);
            },
          },
          {
            text: "Idioma",
            align: "start",
            value: "nivel.idioma.nombre",
            filter: (value) => {
              return this.filtrarIdioma(value);
            },
          },
          {
            text: "Nivel",
            align: "start",
            value: "nivel.descripcion",
            filter: (value) => {
              return this.filtrarNivel(value);
            },
          },
          {
            text: "Días",
            align: "start",
            value: "dia.descripcionCorta",
          },
          {
            text: "Horario",
            align: "start",
            value: "horario.descripcion",
          },
          {
            text: "Aula",
            align: "end",
            value: "aula.numero",
          },
          {
            text: "Grupos",
            align: "end",
            value: "grupos",
          },
          {
            text: "Plazas ocupadas",
            align: "end",
            value: "plazasOcupadas",
          },
        ];

        if (this.userCanEdit || this.userCanEditLlodio) {
          this.headers.push({ text: "", value: "actions", sortable: false });
        }

        await getByCurso(this.cursoActual.id).then((response) => {
          if (!this.locationFilterAllowedRoles.includes(this.userRoles[0])) {
            const allowedLocation = this.userRoles[0]
              .split("ROLE_SUPER_ADMIN_")[1]
              .toLowerCase();

            this.items = response.data.filter(
              (el) => el.localizacion.nombre.toLowerCase() === allowedLocation
            );

            this.searchLocalizacion =
              this.userRoles[0].split("ROLE_SUPER_ADMIN_")[1].substring(0, 1) +
              this.userRoles[0]
                .split("ROLE_SUPER_ADMIN_")[1]
                .substring(1)
                .toLowerCase();

            this.cargarIdiomas();

            this.loading = false;
            return;
          }
          this.items = response.data;
        });
      }

      this.loading = false;
    },

    async refreshItems() {
      this.loading = true;
      this.items = [];
      await getByCurso(this.cursoActual.id).then((response) => {
        if (!this.locationFilterAllowedRoles.includes(this.userRoles[0])) {
          const allowedLocation = this.userRoles[0]
            .split("ROLE_SUPER_ADMIN_")[1]
            .toLowerCase();

          this.items = response.data.filter(
            (el) => el.localizacion.nombre.toLowerCase() === allowedLocation
          );

          this.loading = false;
          return;
        }
        this.items = response.data;
      });
      this.loading = false;

      this.$store.dispatch("App/INITIALIZE_LOCALIZACIONES");
    },

    cargarIdiomas() {
      this.idiomas = [];
      this.searchIdioma = "";

      if (_.isNil(this.searchLocalizacion)) {
        return;
      }

      let localizacionSeleccionada = this.localizaciones.find(
        (localizacion) =>
          localizacion.nombre.toLowerCase() ==
          this.searchLocalizacion.toLowerCase()
      );
      if (_.isNil(localizacionSeleccionada)) {
        return;
      }

      this.idiomas = localizacionSeleccionada.idiomas.map(
        (idioma) => idioma.idioma
      );
    },

    /**
     * valores desponibles en el filtro de nivel teniendo en cuenta el idioma
     */
    cargarNiveles() {
      this.niveles = [];
      this.searchNivel = "";

      if (_.isNil(this.searchLocalizacion)) {
        return;
      }

      let localizacionSeleccionada = this.localizaciones.find(
        (localizacion) =>
          localizacion.nombre.toLowerCase() ==
          this.searchLocalizacion.toLowerCase()
      );
      if (_.isNil(localizacionSeleccionada)) {
        return;
      }

      if (_.isNil(this.searchIdioma)) {
        return;
      }

      let idiomaSeleccionado = localizacionSeleccionada.idiomas.find(
        (idioma) =>
          idioma.idioma.nombre.toLowerCase() == this.searchIdioma.toLowerCase()
      );
      if (_.isNil(idiomaSeleccionado)) {
        return;
      }

      this.niveles = localizacionSeleccionada.niveles.filter(
        (nivel) => nivel.idioma.id == idiomaSeleccionado.idioma.id
      );
    },

    filtrarLocalizacion(value) {
      if (!this.searchLocalizacion) {
        return true;
      }

      if (typeof value == "undefined" || value == null || value == "") {
        return false;
      }

      return value.toLowerCase() == this.searchLocalizacion.toLowerCase();
    },

    /**
     * Filtro Idiomas
     */
    filtrarIdioma(value) {
      // no se ha seleccionado idioma se retornan todos
      if (!this.searchIdioma) {
        return true;
      }

      // se ha seleccionado idioma quitamos todos los valores nulos, vacios y no definidos
      if (typeof value == "undefined" || value == null || value == "") {
        return false;
      }

      // retornamos coincidencias
      return value.toLowerCase() == this.searchIdioma.toLowerCase();
    },

    /**
     * Filtro Nivel
     */
    filtrarNivel(value) {
      if (!this.searchNivel) {
        return true;
      }

      if (typeof value == "undefined" || value == null || value == "") {
        return false;
      }

      return value.toLowerCase() == this.searchNivel.toLowerCase();
    },

    /**
     * Resetear los filtros seleccionados
     */
    borrarFiltros() {
      this.searchLocalizacion = "";
      this.searchIdioma = "";
      this.searchNivel = "";
      this.idiomas = [];
      this.niveles = [];

      if (!this.locationFilterAllowedRoles.includes(this.userRoles[0])) {
        this.searchLocalizacion =
          this.userRoles[0].split("ROLE_SUPER_ADMIN_")[1].substring(0, 1) +
          this.userRoles[0]
            .split("ROLE_SUPER_ADMIN_")[1]
            .substring(1)
            .toLowerCase();

        this.cargarIdiomas();
      }
    },

    addGrupo() {
      // abrir dialog
      this.dialogFullScreen = true;
    },

    async removeGrupo(item) {
      let title = "Borrar grupo";
      let subtitle = "¿Estás seguro?";
      let message = "El grupo se eliminará de forma permanente.";
      let message2 = null;

      // confirmacion
      if (
        await this.$refs.grupoConfirm.open(title, subtitle, message, message2, {
          color: "primary",
          width: 300,
        })
      ) {
        // Si acepta borrar
        let itemIndex = this.items.indexOf(item);

        // Si tenemos indice del elemento en la tabla borramos
        if (itemIndex !== -1) {
          await remove(item)
            .then((response) => {
              if (
                response.status == 204 &&
                response.statusText == "No Content"
              ) {
                // borrar el item del listado
                this.items.splice(itemIndex, 1);
                this.setSnack({
                  active: true,
                  timeout: 1500,
                  color: this.$getStringFor("snack", "successColor"),
                  text: this.$getStringFor("snack", "removeSuccessText"),
                });
              }
            })
            .catch((error) => {
              console.error(error);
              this.setSnack({
                active: true,
                timeout: 1500,
                color: this.$getStringFor("snack", "errorColor"),
                text: this.$getStringFor("snack", "removeErrorText"),
              });
            });
        } else {
          console.error(
            "No ha sido posible borrar el elemento seleccionado, no se encuentra en el listado."
          );
          this.setSnack({
            active: true,
            timeout: 1500,
            color: this.$getStringFor("snack", "errorColor"),
            text: this.$getStringFor("snack", "removeErrorText"),
          });
        }
      }
    },

    /**
     * Metodos para la edicion de la columna aula
     */
    saveAula(item) {
      // comprobar que tenemos identificado el elmento a guardar
      if (this.aulaEditedIndex > -1 && this.aulaTemp != null) {
        // se ha actualizado guardamos ...
        if (
          typeof this.aulaTemp.id != "undefined" ||
          this.aulaEditedItem.aula.id != this.aulaTemp.id
        ) {
          // api post prematriculaAlumno con el nuevo aula
          item.aula = Object.assign({}, this.aulaTemp);

          update(item).then((response) => {
            if (response.status == 200) {
              this.items[this.aulaEditedIndex].aula = Object.assign(
                {},
                response.data.aula
              );
              this.setSnack({
                active: true,
                timeout: 1500,
                color: this.$getStringFor("snack", "successColor"),
                text: this.$getStringFor("snack", "successText"),
              });
            } else {
              this.setSnack({
                active: true,
                timeout: 1500,
                color: this.$getStringFor("snack", "errorColor"),
                text: this.$getStringFor("snack", "errorText"),
              });
            }

            this.resetAulaEditedValues();
          });
        }
      } else {
        this.setSnack({
          active: true,
          timeout: 1500,
          color: this.$getStringFor("snack", "errorColor"),
          text: this.$getStringFor("snack", "errorText"),
        });
        this.resetAulaEditedValues();
      }
    },

    saveAulaTemp(value) {
      this.aulaTemp = Object.assign({}, value);
    },

    cancelAula() {
      this.setSnack({
        active: true,
        timeout: 1500,
        color: this.$getStringFor("snack", "cancelColor"),
        text: this.$getStringFor("snack", "cancelText"),
      });

      this.resetAulaEditedValues();
    },

    openAula(item) {
      this.autocompleteAulasValue = this.parseNumeroAula(item.aula);
      this.aulaEditedIndex = this.items.indexOf(item);
      this.aulaEditedItem = Object.assign({}, item);

      const localizacion = this.localizaciones.find(
        (localizacion) => localizacion.id === item.localizacion.id
      );

      this.aulas = localizacion.aulas;
    },

    closeAula() {
      // hacer algo ...
    },

    resetAulaEditedValues() {
      this.autocompleteAulasValue = "";
      this.aulaEditedIndex = -1;
      this.aulaEditedItem = null;
      this.aulaTemp = null;
    },

    parseNumeroAula(aula) {
      return !_.isNil(aula) ? aula.numero : "";
    },

    /**
     * Metodos para la edicion de la columna grupos
     */
    saveGrupos(item) {
      // comprobar que tenemos identificado el elemento a guardar
      if (this.gruposEditedIndex > -1) {
        // se ha actualizado guardamos ...
        if (this.gruposEditedItem.grupos != this.gruposTemp) {
          // api put con la nueva nota
          item.grupos =
            this.gruposTemp != null ? Object.assign(this.gruposTemp) : null;

          update(item)
            .then((response) => {
              if (response.status == 200) {
                this.items[this.gruposEditedIndex].grupos =
                  response.data.grupos;

                this.setSnack({
                  active: true,
                  timeout: 1500,
                  color: this.$getStringFor("snack", "successColor"),
                  text: this.$getStringFor("snack", "successText"),
                });
              } else {
                this.setSnack({
                  active: true,
                  timeout: 1500,
                  color: this.$getStringFor("snack", "errorColor"),
                  text: this.$getStringFor("snack", "errorText"),
                });
              }

              this.resetGruposEditedValues();
            })
            .catch((error) => console.error(error));
        }
      } else {
        this.setSnack({
          active: true,
          timeout: 1500,
          color: this.$getStringFor("snack", "errorColor"),
          text: this.$getStringFor("snack", "errorText"),
        });

        this.resetGruposEditedValues();
      }
    },

    saveGruposTemp(value) {
      if (value === null) {
        this.gruposTemp = null;
      } else {
        this.gruposTemp = value;
      }
    },

    cancelGrupos() {
      this.setSnack({
        active: true,
        timeout: 1500,
        color: this.$getStringFor("snack", "cancelColor"),
        text: this.$getStringFor("snack", "cancelText"),
      });

      this.resetGruposEditedValues();
    },

    openGrupos(item) {
      this.gruposEditedIndex = this.items.indexOf(item);
      this.gruposEditedItem = Object.assign({}, item);
      this.saveGruposTemp(item.grupos);
    },

    closeGrupos() {
      // hacer algo
    },

    resetGruposEditedValues() {
      this.gruposEditedIndex = -1;
      this.gruposEditedItem = null;
      this.gruposTemp = null;
    },

    /**
     * Cierra el dialog full screen
     */
    closeDialogFullScreen() {
      this.dialogFullScreen = false;
    },

    /**
     * Determina si mostrar o no boton para añadir grupos
     *
     * Mostrar solo, si el año actual es igual al año del curso seleccionado en el combo de cursos (cursoActual)
     */
    isShowAddGrupo() {
      if (this.cursoActual == null) {
        return false;
      }

      let fechaActual = new Date();
      let anioActual = fechaActual.getFullYear();
      let anioCursoActual = parseInt(this.cursoActual.anio);

      return anioCursoActual == anioActual;
    },

    /**
     * Grupo nuevo AÑADIDO desde formulario
     */
    onAddGrupo(event, response) {
      this.items.push(response.data);
      this.setSnack({
        active: true,
        timeout: 1500,
        color: this.$getStringFor("snack", "successColor"),
        text: this.$getStringFor("snack", "successText"),
      });
    },

    /**
     * Grupo nuevo, ERROR al añadir desde el formulario
     */
    onErrorAddGrupo(event, error) {
      console.error(error);
      this.setSnack({
        active: true,
        timeout: 1500,
        color: this.$getStringFor("snack", "errorColor"),
        text: this.$getStringFor("snack", "errorText"),
      });
    },

    /**
     * Determina si mostrar o no el boton para generar los grupos del curso actual
     *
     * Mostrar solo, si el año actual es igual al año del curso seleccionado en el combo de cursos (cursoActual)
     * y no hay grupos creados.
     */
    isShowCrearGrupos() {
      if (this.cursoActual == null) {
        return false;
      }

      if (this.loading) {
        return false;
      }

      if (!_.isEmpty(this.items)) {
        return false;
      }

      let fechaActual = new Date();
      let anioActual = fechaActual.getFullYear();
      let anioCursoActual = parseInt(this.cursoActual.anio);

      return anioCursoActual == anioActual;
    },

    /**
     * Determina si mostrar o no el boton para crear aulas, generar grupos necesarios y repartir a los matriculados
     * lo mas uniformemente posible
     *
     * Mostrar solo, si el año actual es igual al año del curso seleccionado en el combo de cursos (cursoActual)
     * y no se haya ejecutado con anterioridad (curso::gruposAsignados).
     */
    isShowCrearAulas() {
      if (this.cursoActual == null) {
        return false;
      }

      if (this.loading) {
        return false;
      }

      if (_.isEmpty(this.items)) {
        return false;
      }

      if (
        !this.localizaciones.find(
          (localizacion) => !localizacion.ultimoCurso.gruposAsignados
        )
      ) {
        return false;
      }

      return true;
    },

    async crearGrupos() {
      this.loadingCrearGrupos = true;

      let title = "Crear grupos";
      let subtitle = "";
      let message =
        "Usted va a generar automáticamente los grupos del curso actual, partiendo de los del año anterior.";
      let message2 = "¿Está seguro?";

      // confirmacion
      if (
        await this.$refs.grupoConfirm.open(title, subtitle, message, message2, {
          color: "primary",
          width: 300,
        })
      ) {
        // Si acepta duplicamos los grupos
        await duplicar()
          .then(() => {
            this.refreshItems();
          })
          .catch((error) => {
            console.error(error);
          });
      }

      this.loadingCrearGrupos = false;
    },

    async procesoCrearAulas() {
      this.loadingCrearAulas = true;

      let title = "Crear aulas";
      let subtitle = "";
      let message =
        "Usted va a generar automáticamente los grupos necesarios de aquellos grupos con el valor de grupos configurado y a repartir las matrículas entre todos ellos.";
      let message2 = "¿Está seguro?";

      // confirmacion
      if (
        await this.$refs.grupoConfirm.open(title, subtitle, message, message2, {
          color: "primary",
          width: 300,
        })
      ) {
        // Si acepta generamos los grupos y reasignamos las matriculas
        await crearAulas()
          .then(() => {
            this.refreshItems();
            this.setSnack({
              active: true,
              timeout: 1500,
              color: this.$getStringFor("snack", "successColor"),
              text: "La acción se ha ejecutado correctamente",
            });
          })
          .catch((error) => {
            this.setSnack({
              active: true,
              timeout: 3000,
              color: this.$getStringFor("snack", "errorColor"),
              text: error.response.data.message,
            });
          });
      }

      this.loadingCrearAulas = false;
    },
  },
};
</script>
